import { Component } from '@angular/core';
import {CONSTANTES} from '../../../../shared/constanst/url-scrolls-header';
import { FormBuilder, FormGroup, Validators, FormControl, AbstractControl, ValidationErrors } from '@angular/forms';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { Modal } from 'bootstrap';
import { Router } from '@angular/router';
import { RegistroService } from 'src/app/services/registro/registro.service';
import { UsuarioRegistroDTO } from 'src/app/dto/UsuarioRegistroDTO';

@Component({
  selector: 'app-inscribirse',
  templateUrl: './inscribirse.component.html',
  styleUrl: './inscribirse.component.css',
  animations: [
    trigger('fadeInOut', [
      state('void', style({ opacity: 0 })),
      transition(':enter, :leave', [
        animate(500)
      ]),
    ]),
  ],
})
export class InscribirseComponent {
  rutaImagen: string = CONSTANTES.LOGO_DISEÑO_LINEAS_NEGRAS;
  form: FormGroup;
  today: Date;
  maxAge: Date;
  MinAge: Date;
  menorEdad = false;
  campoObligatorio: string = CONSTANTES.CAMPO_OBLIGATORIO;
  modalInstance: Modal | undefined;
  errorMessage: string = '';

  constructor(
    private fb: FormBuilder, 
    private router: Router,
    private registroService: RegistroService) {
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      nombreApellido: ['', Validators.required],
      tipoDocumento: ['dni', Validators.required],
      nroDocumento: ['', [Validators.required, Validators.pattern('^[0-9]+$'),  Validators.minLength(4), Validators.maxLength(11)]],
      fechaNacimiento: ['', Validators.required],
      domicilio: ['', Validators.required],
      localidad: ['', Validators.required],
      provincia: ['', Validators.required],
      codigoPostal: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
      telefono: ['', [Validators.required, Validators.pattern('^[0-9\\s\\+]+$')]],
      correo: ['', [Validators.required, Validators.email]],
      tieneObraSocial: [false, Validators.required],
      obraSocial: [''],
      tieneRepro: [false, Validators.required],
      codigoVinculacion: [''],
      //tutor
      nombreApellidoTutor: [''],
      tipoDocumentoTutor: ['dni'],
      nroDocumentoTutor: [''],
      fechaNacimientoTutor: [''],
      domicilioTutor: [''],
      localidadTutor: [''],
      provinciaTutor: [''],
      codigoPostalTutor: [''],
      vinculoTutorPaciente: [''],
      telefonoTutor: [''],
      correoTutor: [''],
      
    });

    // Change in ObraSocial
    this.form.get('tieneObraSocial')?.valueChanges.subscribe(value => {
      const control = this.form.get('obraSocial');
      if (value === true)
        control?.setValidators([Validators.required]);
      else
        control?.clearValidators();

      control?.updateValueAndValidity(); // Recalcula la validez después de actualizar las validaciones
    });


    // Change in TieneRepro
    this.form.get('tieneRepro')?.valueChanges.subscribe(value => {
      const control = this.form.get('codigoVinculacion');
      if (value === true)
        control?.setValidators([Validators.required]);
      else
        control?.clearValidators();
        
      control?.updateValueAndValidity(); // Recalcula la validez después de actualizar las validaciones
    });

  }

  onSubmit(): void {
    if (this.form.valid) {
      console.log(this.form.value);

      let request: UsuarioRegistroDTO = this.returnRequest();

      this.registroService.registrarUsuario(request).subscribe(response => {
        console.log(response);

        let requestEmial = {
          email: this.form.get('correo').value
        };

        // this.registroService.enviarEmailConfirmacion(requestEmial).subscribe(response => {
        //   this.openModalFormularioExitoso();
        // }, error => {
        //   this.openModalErrorServicio();
        //   console.error('Error al enviar email confirmación. Contactece con su proveedor: ', error);
        //   this.errorMessage = 'Contactece con su proveedor';
        // });

        this.registroService.enviarEmailConfirmacion(requestEmial).subscribe({
          next: (response) => {
            this.openModalFormularioExitoso();
          },
          error: (error) => {
            console.error('Error al enviar email de confirmación:', error.message);
            this.openModalErrorServicio();
            this.errorMessage = error.message || 'Contacte con su proveedor';
          }
        });        
        
      }, error => {
        console.error('Error al iniciar sesión:', error);
        this.errorMessage = 'Credenciales incorrectas';
      });

    } else {
      this.form.markAllAsTouched();
      console.log('Formulario inválido');
      // this.mostrarErroresFormulario(this.form);
      this.openModalConfirmarCodigoRepro();
    }
  }

  returnRequest(): UsuarioRegistroDTO {

    
      return {
        nombreApellido: this.form.get('nombreApellido').value,
        email: this.form.get('correo').value,
        password: "1234",
        tipo: this.form.get('tipoDocumento').value,
        nroDocumento: this.form.get('nroDocumento').value,
        direccion: this.form.get('domicilio').value,
        fechaNacimiento: this.form.get('fechaNacimiento').value,
        idReprocan: this.form.get('codigoVinculacion').value,
        suscripto: this.form.get('obraSocial').value,
        roles: ["ROLE_USER"], //MODIFICAR PARA QUE SE FIRME LOS PERMISOS DENTRO DEL BACKEND
        //Tutor
  
        nombreApellidoTutor: this.form.get('nombreApellidoTutor').value,
        tipoDocumentoTutor: this.form.get('tipoDocumentoTutor').value,
        nroDocumentoTutor: this.form.get('nroDocumentoTutor').value,
        fechaNacimientoTutor: this.form.get('fechaNacimientoTutor').value,
        domicilioTutor: this.form.get('domicilioTutor').value,
        localidadTutor: this.form.get('localidadTutor').value,
        provinciaTutor: this.form.get('provinciaTutor').value,
        codigoPostalTutor: this.form.get('codigoPostalTutor').value,
        vinculoTutorPaciente: this.form.get('vinculoTutorPaciente').value,
        telefonoTutor: this.form.get('telefonoTutor').value,
        correoTutor: this.form.get('correoTutor').value
      }
  }

  onDateChange(event: any) {
    const selectedDate = event.target.value;
    const isAdult = this.checkIfAdult(selectedDate);
    
    if (isAdult) {
      this.menorEdad = false;
      console.log("Es mayor de 18 años");
      this.deshabilitarValidadoresTutor();
    } else {
      console.log("No es mayor de 18 años");
      this.menorEdad = true;
      this.habilitarValidadoresTutor();
    }
  }

  habilitarValidadoresTutor(): void {
    const tutorFields = [
      'nombreApellidoTutor', 
      'tipoDocumentoTutor',
      'nroDocumentoTutor',
      'fechaNacimientoTutor',
      'domicilioTutor',
      'localidadTutor',
      'provinciaTutor',
      'codigoPostalTutor',
      'vinculoTutorPaciente',
      'telefonoTutor',
      'correoTutor',
    ];
  
    tutorFields.forEach(field => {
      const control = this.form.get(field);
      if (control) {

        if (field === 'nroDocumentoTutor') {
          control.setValidators([
            Validators.required,
            Validators.pattern('^[0-9]+$'),
            Validators.minLength(4),
            Validators.maxLength(11),
          ]);
        } else if (field === 'codigoPostalTutor' || field === 'telefonoTutor') {

          control.setValidators([
            Validators.required,
            Validators.pattern('^[0-9]+$')
          ]);

        } else if (field === 'correoTutor') {
          
          control.setValidators([
            Validators.required,
            Validators.email
          ]);

        } else if (field === 'fechaNacimientoTutor') {
          control.setValidators([
            Validators.required,
            this.validateAdult // 🔹 Agregamos la validación personalizada
          ]);
        } else {
          control.setValidators(Validators.required);
        }

        control.updateValueAndValidity();
      }
    });
  }

  validateAdult(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return null; // Si no hay fecha, no validamos
  
    const birthDate = new Date(control.value);
    const today = new Date();
    const age = today.getFullYear() - birthDate.getFullYear();
  
    // Verifica si ya cumplió años este año
    const hasBirthdayPassed =
      today.getMonth() > birthDate.getMonth() ||
      (today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate());
  
    const finalAge = hasBirthdayPassed ? age : age - 1;
  
    return finalAge >= 18 ? null : { notAdult: true }; // Retorna error si no es adulto
  }

  deshabilitarValidadoresTutor(): void {
    const tutorFields = [
      'nombreApellidoTutor',
      'tipoDocumentoTutor',
      'nroDocumentoTutor',
      'fechaNacimientoTutor',
      'domicilioTutor',
      'localidadTutor',
      'provinciaTutor',
      'codigoPostalTutor',
      'vinculoTutorPaciente',
      'telefonoTutor',
      'correoTutor',
    ];
  
    tutorFields.forEach(field => {
      const control = this.form.get(field);
      if (control) {
        control.clearValidators();
        control.updateValueAndValidity();
      }
    });
  }
    
  checkIfAdult(birthDate: string): boolean {
    const today = new Date();
    const birth = new Date(birthDate);
    const age = today.getFullYear() - birth.getFullYear();
    const month = today.getMonth() - birth.getMonth();
    
    // Si el mes actual es anterior al mes de nacimiento o si estamos en el mismo mes pero antes del día de nacimiento
    if (month < 0 || (month === 0 && today.getDate() < birth.getDate())) {
      return age >= 18; // Mayor de 18 si la edad es 18 o más
    }
    
    return age >= 18; // Mayor de 18 si la edad es 18 o más
  }

  openModalConfirmarCodigoRepro() {
    const modalElement = document.getElementById('modalReviseCambios');
    if (modalElement) {
      this.modalInstance = new Modal(modalElement);
      this.modalInstance.show();
    }
  }


  openModalFormularioExitoso() {
    const modalElement = document.getElementById('modalFormularioExitoso');
    if (modalElement) {
      this.modalInstance = new Modal(modalElement);
      this.modalInstance.show();
    }
  }

  openModalErrorServicio() {
    const modalElement = document.getElementById('errorServicio');
    if (modalElement) {
      this.modalInstance = new Modal(modalElement);
      this.modalInstance.show();
    }
  }

  closeModals() {
    if (this.modalInstance) {
      this.modalInstance.hide();
    }
  }

  irConfirmarUsuario() {
    this.router.navigate(['/']);
  }
}
